
import React from 'react'
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

// const datum = [20, 18, 10, 28, 23, 12, 25]
// const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]


function LineChart(props) {
  const data = [
    ...props.xAxis.data.map(
      (x, i) => {
        return {
          [props.xAxis.key]: x,
          [props.yAxis.key]: props.yAxis.data[i]
        }
      }
    )
  ];
  return (
    <ResponsiveContainer width="100%" height="73%">
      <AreaChart
        width={500}
        height={400}
        data={data}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey={props.xAxis.key}/>
        <YAxis />
        <Tooltip />
        <Area type="monotone" dataKey={props.yAxis.key} stroke="#1976e8" fill="#1976D2" />
      </AreaChart>
    </ResponsiveContainer>
  );
}

export default LineChart